import React, {Component} from 'react'

// import styles
import './StopOtherOrders.scss'

// Elements
import ModalHeader from '../../elements/modalHeader'
import BottomBar from '../../elements/bottomBar'

class StopOtherOrders extends Component {

  render () {
    let higher = this.props.higher ? 'higher' : ''
    return (
      <div className='confirm_OrderStop_modal__wrapper'>
        <div className={'backdrop__modal ' + higher} />
        <div className='confirm__modal'>
          <div className='confirm__content'>
            <ModalHeader text={this.props.t('2312')} />
            {this.props.renderText(this.props)}
          </div>
          <BottomBar
            actionLabelText={this.props.t('381')}
            onActionClick={this.props.AllOrders}
            cancelLabelText={this.props.t('2314')}
            onCancelClick={this.props.NotAllOrders}
          />
        </div>
      </div>
    )
  }

}

StopOtherOrders.defaultProps = {
  renderText: (props) => {
    let txt = ''
    if (props.Move) {
      txt = props.t('2316')
    } else if (props.Stop) {
      txt = props.t('2315')
    } else {
      txt = props.t('2313')
    }
    return (
      <div className='pg-pb-2'>
        {txt}
      </div>
    )
  }
}

export default StopOtherOrders



// WEBPACK FOOTER //
// ./src/app/shared/components/StopOtherOrders/index.js